export function validateCPF( cpf ) {
    let mod, total = 0, i = 0, sequence = 10

    for (let x = sequence; x > 1; x--) {
        total += (x * Number(cpf[i]))
        i++
    }

    mod = Number(total * 10 % 11)
    if(mod === 10) mod = 0

    if (!(Number(cpf[9]) === mod))  
        return false  

    total = 0
    i = 0
    mod = 0
    for (let x = sequence + 1; x > 1; x--) {
        total += x * Number(cpf[i])
        i++
    }
    mod = Number(total * 10 % 11)
    if(mod === 10) mod = 0

    if (!(Number(cpf[10]) === mod)) {
        return false
    }
    return true
}


// WEBPACK FOOTER //
// ./src/components/parts/document-component/validate-cpf.js